import Vue from 'vue'
import Router from 'vue-router'
import addCloud from '@/components/workspace/add_cloud'
import addEmail from '@/components/workspace/add_email'
import cloudExploer from '@/components/workspace/cloud_exploer'
import emailExploer from '@/components/workspace/email_exploer'
import login from '@/components/login'
import mcLite from '@/components/mc_lite'
import mcProject from '@/components/mc_project'
import turnPage from '@/components/turn_page';
import turnLoginPage from '@/components/turn_login_page';
import preview from '@/components/workspace/preview'
import cloudTransfer from '@/components/workspace/cloud_transfer'
import emailTransfer from '@/components/workspace/email_transfer'
import cloudSync from '@/components/workspace/cloud_sync'
// import taskList from '@/components/workspace/task_list';
import taskList from '@/components/workspace/task_list_new';
import remoteTask from '@/components/workspace/remote_task';
import encryption from '@/components/workspace/encryption';
import shares from '@/components/workspace/shares';
import paySys from '@/components/workspace/pay_system';
import homePage from '@/components/workspace/home';
import commonUtils from "@/js/workspace/common_util.js";
import GaUtil from "@/js/workspace/google_analytics_util.js";
import inviteFriends from '@/components/workspace/inviteFriends';
import subAccountTeam from '@/components/workspace/sub_account_team';
import cloudBackup from '@/components/workspace/cloud_backup';
import imageSaverIns from '@/components/workspace/image_saver_ins';
import imageSaverWeb from '@/components/workspace/image_saver_web';
import imageSaverTask from '@/components/workspace/image_saver_task';
import affiliateProgram from '@/components/workspace/affiliateProgram';
import extensionRurn from '@/components/extension_turn';
// import paySysActivity from '@/components/workspace/pay_system_activity';
import teamTransfer from '@/components/workspace/team_transfer';
import shareTransfer from '@/components/share_transfer';
import videoSaver from '@/components/workspace/video_saver';
import videoSaverTask from '@/components/workspace/video_saver_list';
Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [{
            path: '/turn_page',
            name: 'turnPage',
            component: turnPage
        },
        {
            path: '/turn_login_page',
            name: 'turnLoginPage',
            component: turnLoginPage
        },
        {
            path: '/share/:shareId',
            name: 'share',
            component: () =>
                import ('@/components/share_page'),
            props: true,
            meta: {
                name: "robots",
                content: "noindex,nofollow,all",
            }
        },
        {
            path: '/mc_project/share_transfer',
            name: 'shareTransfer',
            component: shareTransfer
        },
        {
            path: '/',
            redirect: {
                name: 'turnLoginPage',
                component: turnLoginPage
            }
        },
		{
            path: '/mc_lite',
            name: 'mcLite',
            component: mcLite,
        }, 
          {
            path: '/mc_project',
            name: 'mcProject',
            component: mcProject,
            redirect: {
                name: 'homePage'
            },
            children: [{
                    path: '/mc_project/home_page',
                    name: 'homePage',
                    component: homePage
                }, {
                    path: '/mc_project/add_cloud',
                    name: 'addCloud',
                    component: addCloud
                },
                {
                    path: '/mc_project/add_email',
                    name: 'addEmail',
                    component: addEmail
                },
                {
                    path: '/mc_project/cloud_exploer',
                    name: 'cloudExploer',
                    component: cloudExploer,
                },
                {
                    path: '/mc_project/email_exploer',
                    name: 'emailExploer',
                    component: emailExploer,
                },
                {
                    path: '/mc_project/cloud_exploer/preview',
                    name: 'preview',
                    component: preview
                },
                {
                    path: '/mc_project/task_list',
                    name: 'taskList',
                    component:taskList
                },
                {
                    path: '/mc_project/cloud_transfer',
                    name: 'cloudTransfer',
                    component: cloudTransfer,
                  
                },
                {
                    path: '/mc_project/email_transfer',
                    name: 'emailTransfer',
                    component: emailTransfer,
                  
                },
                {
                    path: '/mc_project/team_transfer',
                    name: 'teamTransfer',
                    component: teamTransfer,
                },
                {
                    path: '/mc_project/cloud_backup',
                    name: 'cloudBackup',
                    component: cloudBackup
                },
                {
                    path: '/mc_project/image_saver_ins',
                    name: 'imageSaverIns',
                    component: imageSaverIns
                },
                {
                    path: '/mc_project/image_saver_web',
                    name: 'imageSaverWeb',
                    component: imageSaverWeb
                },
                {
                    path: '/mc_project/image_saver_task',
                    name: 'imageSaverTask',
                    component: imageSaverTask
                },
                {
                    path: '/mc_project/cloud_sync',
                    name: 'cloudSync',
                    component: cloudSync,
                },
                {
                    path: '/mc_project/remote_task',
                    name: 'remoteTask',
                    component: remoteTask
                },
                {
                    path: '/mc_project/shares',
                    name: 'shares',
                    component: shares
                },
                {
                    path: '/mc_project/encryption',
                    name: 'encryption',
                    component: encryption
                },
                {
                    path: '/mc_project/paySys',
                    name: 'paySys',
                    component: paySys
                },
                {
                    path: '/mc_project/inviteFriends',
                    name: 'inviteFriends',
                    component: inviteFriends
                },
                {
                    path: '/mc_project/subAccountTeam',
                    name: 'subAccountTeam',
                    component: subAccountTeam,
                },
                {
                    path: '/mc_project/affiliateProgram',
                    name: 'affiliateProgram',
                    component: affiliateProgram,
                },
                // {
                //     path: '/mc_project/paySysActivity',
                //     name: 'paySysActivity',
                //     component: paySysActivity
                // },
                {
                    path: '/mc_project/video_saver',
                    name: 'videoSaver',
                    component: videoSaver
                },
                {
                    path: '/mc_project/video_saver_task',
                    name: 'videoSaverTask',
                    component: videoSaverTask
                },
            ]
        },
        {
            path: '/extension_turn',
            name: 'extensionRurn',
            component: extensionRurn
        },
    ],
})
router.beforeEach((to, form, next) => {
    if (to.path == '/login') {
        localStorage.removeItem("user");
        next();
        return;
    }
    if(to.meta.content) {     //路由发生变化时候修改meta中的content
        let head = document.getElementsByTagName('head');
        let meta = document.createElement('meta');
        meta.name = to.meta.name;
        meta.content = to.meta.content;
        head[0].appendChild(meta);
    }
    commonUtils.getNewUser(function(res){
        var user =res;
        if (!user && to.name != 'paySys' && to.name != 'paySysActivity' && to.path != '/login' && to.name !== 'share' 
        && to.name !== 'turnPage' && to.path != '/turn_login_page' && to.path != '/mc_project/share_transfer') {
            next({ path: '/' })
        } else {
            next();
        }
    });
    //hash模式转化history模式
    if(to.hash&&to.hash.indexOf("#/share/")!=-1){
        next({ path: to.hash.substr(1) })
    }
  
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    // if(originalPush.call(this, location)){
    // }
    //避免冗余跳转报错
    // return originalPush.call(this, location).catch(err => err)
    try {
        originalPush.call(this, location);
    } catch (error) {
        return error;
    }
}
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js